import { TGoogleLoginRequest, TGoogleLoginResponse } from "@/features/auth/types/google-login";
import { TApiRes } from "@/types/api";
import { clientApi } from "@/utils/api";
import { setToken } from "@/utils/token";
import Cookies from "js-cookie";

export const googleLoginApi = async (payload: TGoogleLoginRequest): Promise<TGoogleLoginResponse> => {
  const {
    data: { data },
  } = await clientApi.post<TApiRes<TGoogleLoginResponse>>("/login-google", payload);

  setToken(data.accessToken, data.refreshToken);
  Cookies.set("admin-email", data.email);
  return data;
};
